var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15343_12613)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15343_12613)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2858 15.3131C27.2858 14.9721 27.1503 14.645 26.9092 14.4039C26.6681 14.1628 26.341 14.0273 26 14.0273C25.6591 14.0273 25.332 14.1628 25.0909 14.4039C24.8498 14.645 24.7143 14.9721 24.7143 15.3131V17.4096C22.8759 17.686 21.1745 18.5447 19.8601 19.8594C18.5457 21.1741 17.6875 22.8757 17.4115 24.7142H15.3115C14.9705 24.7142 14.6435 24.8497 14.4023 25.0908C14.1612 25.3319 14.0258 25.6589 14.0258 25.9999C14.0258 26.3409 14.1612 26.6679 14.4023 26.9091C14.6435 27.1502 14.9705 27.2856 15.3115 27.2856H17.408C17.6845 29.1241 18.5431 30.8254 19.8578 32.1398C21.1726 33.4543 22.8741 34.3125 24.7126 34.5885V36.6868C24.7126 37.0278 24.8481 37.3548 25.0892 37.5959C25.3303 37.837 25.6573 37.9725 25.9983 37.9725C26.3393 37.9725 26.6663 37.837 26.9075 37.5959C27.1486 37.3548 27.284 37.0278 27.284 36.6868V34.5902C29.1225 34.3138 30.8238 33.4552 32.1383 32.1404C33.4527 30.8257 34.3109 29.1241 34.5869 27.2856H36.6852C37.0262 27.2856 37.3532 27.1502 37.5943 26.9091C37.8354 26.6679 37.9709 26.3409 37.9709 25.9999C37.9709 25.6589 37.8354 25.3319 37.5943 25.0908C37.3532 24.8497 37.0262 24.7142 36.6852 24.7142H34.5886C34.3123 22.876 33.4539 21.1748 32.1395 19.8604C30.8251 18.546 29.1239 17.6877 27.2858 17.4113V15.3131ZM32.1132 25.9896C32.1112 24.7814 31.7512 23.601 31.0787 22.5972C30.4061 21.5935 29.4513 20.8116 28.3347 20.3501C27.2181 19.8887 25.9898 19.7685 24.8049 20.0047C23.62 20.241 22.5317 20.823 21.6774 21.6773C20.8231 22.5316 20.2411 23.6199 20.0049 24.8048C19.7687 25.9897 19.8889 27.218 20.3503 28.3346C20.8117 29.4512 21.5936 30.406 22.5974 31.0785C23.6011 31.751 24.7816 32.111 25.9898 32.1131H26.0103C27.6281 32.1103 29.1788 31.4665 30.3227 30.3226C31.4666 29.1787 32.1105 27.6279 32.1132 26.0102V25.9896ZM23.8915 25.9999C23.8915 25.4407 24.1136 24.9044 24.5091 24.5089C24.9045 24.1135 25.4408 23.8913 26 23.8913C26.5593 23.8913 27.0956 24.1135 27.491 24.5089C27.8865 24.9044 28.1086 25.4407 28.1086 25.9999C28.1086 26.5591 27.8865 27.0955 27.491 27.4909C27.0956 27.8863 26.5593 28.1085 26 28.1085C25.4408 28.1085 24.9045 27.8863 24.5091 27.4909C24.1136 27.0955 23.8915 26.5591 23.8915 25.9999Z",
    fill: "#1E1E1E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15343_12613",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15343_12613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15343_12613",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15343_12613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current_location.02baacf3da67a1c281134f10f262978d.svg";
export { ForwardRef as ReactComponent };